export default "/images/framework/Badge_06.36048b5d.svg?36048b5d";